import { apiProductNatures } from '@spo/services/api';
import { useMutation } from '@tanstack/react-query';

export const usePatchSportNatureStatus = (
  sportId: string,
  productNatureId: number,
  enabled: boolean,
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['usePatchSportNatureStatus', sportId, productNatureId],
    mutationFn: () =>
      apiProductNatures.patchProductNature({
        sportId: parseInt(sportId, 10),
        productNatureId,
        enabled,
        language: 'EN',
      }),
    onSuccess,
    onError,
  });
};
